var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticClass:"neu-glow",attrs:{"right":!_vm.isSidenavPostionRight,"value":_vm.drawer,"floating":"","stateless":"","temporary":"","hide-overlay":"","app":"","width":"300"}},[_c('app-settings',{attrs:{"handleDrawer":_vm.handleDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }